




















import {
  BasePrimaryButton,
  BaseNumericTag
} from "@web-components";
import { useDictionary } from "../views/compositions/useDictionary";

export default {
  components: {
    BasePrimaryButton,
    BaseNumericTag
  },
  props: {
    activityCount: {
      type: Number,
      required: true
    }
  },
  setup() {
    const dictionary = useDictionary();
    return {
      ...dictionary
    };
  }
};
